export default function earlyaccess() {
  return (
    <div className="early-container">
      <div className="early-card">
        <h3>Get early access today</h3>
        <p>
          It only takes a minute to sign up and our free starter tier is
          extremely generous. If you have any questions, our support team would
          be happy to help you.
        </p>
        <input type="email" placeholder="johndoe@emample.com" />
        <button>get started for free</button>
      </div>
    </div>
  );
}
